import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'webapp/environments/environment';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      var poolData = {
        UserPoolId: environment.UserPoolId, // Your user pool id here
        ClientId: environment.ClientId, // Your client id here
      };
      var userPool = new CognitoUserPool(poolData);
      var currentUser = userPool.getCurrentUser();
      if(currentUser != null){
        currentUser.getSession((err:any,session:any)=>{
          if (err) {
            // this.alertService.error(err.message || JSON.stringify(err));
            return false;
          }
          const isAuthorized = session.isValid();
          if (!isAuthorized) {
            this.router.navigate(['accessdenied']);
          }
          return isAuthorized;
        });
      }else{
        return true;
      }
      
      //   const allowedRoles = next.data.allowedRoles;
      //   const isAuthorized = this.authorizationService.isAuthorized(allowedRoles);
       
      // if (!isAuthorized) {
      //     this.router.navigate(['accessdenied']);
      //   }

      // return isAuthorized;
      
      }

      canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      
        var poolData = {
          UserPoolId: environment.UserPoolId, // Your user pool id here
          ClientId: environment.ClientId, // Your client id here
        };
        var userPool = new CognitoUserPool(poolData);
        var currentUser = userPool.getCurrentUser();
        if(currentUser != null){
          currentUser.getSession((err:any,session:any)=>{
            if (err) {
              // this.alertService.error(err.message || JSON.stringify(err));
              return false;
            }
            const isAuthorized = session.isValid();
            if (!isAuthorized) {
              this.router.navigate(['accessdenied']);
            }
            return isAuthorized;
          });
        }
        return false;
      
        //   const allowedRoles = next.data.allowedRoles;
      //   const isAuthorized = this.authorizationService.isAuthorized(allowedRoles);

      // if (!isAuthorized) {
      //     this.router.navigate(['accessdenied']);
      //   }

      // return isAuthorized
      }
}